/* istanbul ignore file -- file not needed in testing coverage */
// src/DynatracePlaceholder.jsx
import { getEnvironmentSelector } from '@americanexpress/travel-selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import attrsE2 from '../generated/dynatraceAttrs.json';
import attrsE3 from '../generated/dynatraceAttrsE3.json';

const useTravelDynatrace = () => {
  const environment = useSelector(getEnvironmentSelector);
  const attrs = environment === 'e3' ? attrsE3 : attrsE2;
  useEffect(() => {
    if (!attrs || !attrs.src) return;

    // Avoid duplicating the placeholder
    if (document.querySelector('#dynatrace-agent-placeholder')) return;

    const script = document.createElement('script');
    script.type = 'text';
    script.id = 'dynatrace-agent-placeholder';
    script.setAttribute('src', attrs.src);
    if (attrs.integrity) script.setAttribute('integrity', attrs.integrity);
    if (attrs.crossorigin) script.setAttribute('crossorigin', attrs.crossorigin);
    if (attrs.dtconfig) script.setAttribute('data-dtconfig', attrs.dtconfig);

    document.head.appendChild(script);
  }, []);

  // render nothing into the React tree; all work is done in head
  return null;
};

export default useTravelDynatrace;
